import React,{ useEffect, useState } from "react";
import { setCurrentProvider, updateEgressProvider } from "../../../actions/actionEgressProvider";
import EgressProviderForm from "../EgressProviderForm/EgressProviderForm";
import {useTranslation} from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowProgress } from '@fortawesome/pro-light-svg-icons/faArrowProgress';
import PageHeader, { parentRoutes } from "../../../components/Header/PageHeader";
import { Form } from "../../../components/Form/Form"
import EgressGateway from "../../EgressGateway/EgressGateway";
import { useDispatch, useSelector } from "react-redux";
import ViewEgressProvider from "../ViewEgressProvider"

const parentRouteList = parentRoutes('/egress_providers')
const newRoutes = [
    ...parentRouteList.routes,
    {name: "generic.update",path:"/update_egress_provider",isActive: true},
];

export default function UpdateEgressProvider(props) {
    const [currentTab, setCurrentTab] = useState('form');
    const { t } = useTranslation('common');
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setCurrentProvider(props.match.params.id))
    }, []);

    const tabList = [
        { name: 'buttons.Edit', key: 'form' },
        { name: 'egress_provider.details', key: 'details'},
        { name: 'egress_provider.egress-gateways', key: 'gateway' }
    ]
    
    const userData = {
        egress_provider_id: props.match.params.id
    }
    const onSuccess = () => {
        props.history.push('/egress_providers');
    }

    return (
        <div>
            <PageHeader location={props.location} routes={typeof newRoutes !== 'undefined' ? newRoutes : null} title={t('egress_provider.update-egress-provider')} icon={<FontAwesomeIcon icon={faArrowProgress} />} />
            <Form 
                {...props}
                tabList={tabList}
                currentTab={currentTab}
                setCurrentTab={setCurrentTab}
                userData={userData}
                section="egress_provider"
                type="update"
                dispatchFunc={updateEgressProvider}
                onSuccess={onSuccess}
                form={<EgressProviderForm egressProviderId={props.match.params.id}  {...props} />}
                tabs={<ViewEgressProvider currentTab={currentTab} {...props} />}
            />
        </div>
    )
}
